export function getcheckedInPatientList(): string {
  return 'invoices/clinical-patients/?checked_in=true';
}

export function getbillingConfigURL(): string {
  return 'billing/billing-config-options/?module=patient_advance';
}

export function postcheckedInadvanceURL(): string {
  return 'patient-advances/checkin/credit/';
}

export function postrefundRequestURL(): string {
  return 'patient-advances/refund/';
}

export function getAdvanceRequestPatientList(): string {
  return 'patient-advances/requests/';
}

export function getRecievedRequestPatientList(): string {
  return 'patient-advances/credit-history/';
}

export function postMakeAdvancePaymentURL(): string {
  return 'payments/';
}

export function getcheckedInAdvanceLogsURL(): string {
  return 'patient-advances/checkin/transactions/';
}

export function getAdvancesStatsURL(): string {
  return 'patient-advances/patient-advance-stats/';
}

export function getAdvanceReceiptURL(creditTransactionId: number): string {
  return `patient-advances/${creditTransactionId}/transaction-log/receipt/`;
}

/**
 * Get patient wallet/advance balance detail
 * Returns: { balance_amount, total_paid_amount, total_used_amount, hold_amount, refund_amount }
 */
export function getPatientWalletBalanceURL(patientId: number | string): string {
  return `patient-advances/${patientId}/checkin/detail/`;
}

